import { render, staticRenderFns } from "./AddThirdProject-view.vue?vue&type=template&id=700b5517&scoped=true&"
import script from "./AddThirdProject-view.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddThirdProject-view.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddThirdProject-view.vue?vue&type=style&index=0&id=700b5517&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b5517",
  null
  
)

export default component.exports